import { mapDTO } from '@twistezo/ts-dto-mapper'

import { TransferListItem } from 'components/Form/TransferList'
import { PageForAdUnitTransferListDTO } from 'features/inventory/api/types/pageForAdUnitTransferListDTO'

export const pageForTransferListFromDTO = (from: PageForAdUnitTransferListDTO): TransferListItem =>
  mapDTO<PageForAdUnitTransferListDTO, TransferListItem>({ from }).transform(({ id, name }) => ({
    label: name,
    value: id,
  }))
